import { createContext, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings } from 'lucide-react';

const SettingsSlot = createContext(null);

export function PageNavigation({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [slot, setSlot] = useState(null);
  return <SettingsSlot.Provider value={slot}>
    <div className="mb-5 flex min-h-10 items-center justify-between gap-4 print:hidden" data-testid="page-navigation">
      {location.pathname !== '/' ? <button type="button" data-testid="back-button" onClick={() => window.history.state?.idx > 0 ? navigate(-1) : navigate('/', { replace: true })} className="inline-flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-slate-900"><ArrowLeft className="h-4 w-4" />Back</button> : <span />}
      <div ref={setSlot} className="ml-auto flex shrink-0 items-center justify-end" data-testid="page-settings-slot" />
    </div>
    {children}
  </SettingsSlot.Provider>;
}

export function PageSettingsButton({ active = false, inline = false, className = '', ...props }) {
  const slot = useContext(SettingsSlot);
  const button = <button type="button" title="Edit" aria-label="Edit" {...props} className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border ${active ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-100'} focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-600 ${className}`}><Settings aria-hidden="true" className="h-5 w-5" /></button>;
  return slot && !inline ? createPortal(button, slot) : button;
}
